import NewButton from '$tablet-app/src/app/components/Button/NewButton';
import Dialog from '$tablet-app/src/app/components/Dialog';
import { DialogProps } from '$tablet-app/src/app/components/Dialog/Dialog';
import DialogBody from '$tablet-app/src/app/components/Dialog/DialogBody';
import DialogBottomActions from '$tablet-app/src/app/components/Dialog/DialogBottomActions';
import DialogHeader from '$tablet-app/src/app/components/Dialog/DialogHeader';
import LoadingSpinner from '$tablet-app/src/app/components/LoadingSpinner';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import { Text } from '@akin-home/text/native';
import { isRobotUser } from '@akin-home/utils/native';
import { View } from 'react-native';
import styled from 'styled-components/native';

interface Props extends DialogProps {
  onConfirm?: () => void;
  isLoading?: boolean;
}

export const ToggleRobotUserDialog = ({
  onConfirm,
  onClose,
  isLoading = false,
  ...dialog_props
}: Props) => {
  const robotModeEnabled = isRobotUser();

  return (
    <Dialog {...dialog_props}>
      <DialogHeader
        center={
          <Text variant="h3" weight="semibold">
            {robotModeEnabled ? 'Disable Robot Mode' : 'Enable Robot Mode'}
          </Text>
        }
      />
      <Body>
        <Text>Continuing with this action will sign you out</Text>
      </Body>

      <DialogBottomActions>
        <Row>
          <NewButton variant="secondary" onPress={onClose} disabled={isLoading}>
            Cancel
          </NewButton>

          <>
            <Spacer width="16px" />
            <NewButton onPress={onConfirm} disabled={isLoading}>
              Continue
            </NewButton>
          </>
        </Row>
      </DialogBottomActions>

      {isLoading ? (
        <LoadingOverlay>
          <LoadingSpinner size={'large'} />
        </LoadingOverlay>
      ) : null}
    </Dialog>
  );
};

const Body = styled(DialogBody)`
  align-items: center;

  padding: 50px;
`;

const LoadingOverlay = styled(View)`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #ffffff81;
  justify-content: center;
`;
